<template>
  <div id="app">
    <div class="content">
      <router-view></router-view>
    </div>
    <!-- <div class="tab-bar">
      <cube-tab-bar
            v-model="selectedLabelDefault" 
            :data="tabs" 
            show-slider 
            @change="changeHandler">
        <cube-tab 
            v-for="item in tabs" 
            :label="item.label" 
            :icon="item.icon"
            :value="item.routeName" 
            :key="item.routeName">
        </cube-tab>
      </cube-tab-bar>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'app',
  // data() {
  //   return {
  //     // selectedLabelDefault: 'privacyPolicy',
  //     selectedLabelDefault: 'home',
  //   //   tabs: [
  //   //     {
  //   //       label: '主页',
  //   //       icon: 'cubeic-home',
  //   //       routeName: 'home'
  //   //     },
  //   //     {
  //   //       label: '收藏',
  //   //       icon: 'cubeic-like',
  //   //       routeName: 'like'
  //   //     },
  //   //     {
  //   //       label: '我的',
  //   //       icon: 'cubeic-person',
  //   //       routeName: 'mine'
  //   //     }
  //   //   ]
  //   }
  // },
  methods: {
    changeHandler(routeName) {
      if (this.$router.currentRoute.name != routeName) {
        this.$router.replace({name: routeName})
      }
    },
    pushPath(name,query){
        this.$router.replace({name: name,query:query})
    }
  },
  mounted: function() {
    let suffix = process.env.ENV_MODE == 'dev' ? ' - 开发版' : process.env.ENV_MODE == 'test' ? ' - 测试版' : ''
    document.title = process.env.APP_NAME + suffix
    if(this.$route.query.path){
        this.pushPath(this.$route.query.path,this.$route.query)
    }
    // else{
    //     this.changeHandler(this.selectedLabelDefault)
    // }

  }
}
</script>

<style>
  #app{
    background-color:#ededed;
  }
    
    .header{
      text-align: center;
      color:#ffffff;
      background-color:#f18934;
    }
      
      .title{
        padding:20px 0;
        font-size: 16px;
        color: #ffffff;
        display: inline-block;
      }

    .content{
      text-align: center;
      height: calc(100% - 80px);
      overflow: hidden;
    }

    .tab-bar {
        background-color:#ffffff;
        bottom: 1px;
        position:fixed;
        width: 100%;
        height:52px;
    }


</style>
